import { Box, Card, ThemeIcon, Title } from "@mantine/core";
import { Group, Paper, Stack } from "@mantine/core";
import { IconNumber2Small, IconPlus } from "@tabler/icons-react";
import { Divider } from "@mantine/core";
import { Product } from "@jasper/client-models";
import { Text } from "@mantine/core";
import { ProductDetails } from "./ProductsDetails";
import { UnstyledButton } from "@mantine/core";

export const ProductsSummary = ({
  products,
  onEdit,
  onDelete,
  onAdd,
}: {
  products: Product[];
  onEdit: (productId: string) => void;
  onDelete: (productId: string) => void;
  onAdd: () => void;
}) => {
  return (
    <Paper shadow="xs" p="xl" withBorder>
      <Stack gap="md">
        <Group>
          <ThemeIcon radius="xl" variant="light" c="primary">
            <IconNumber2Small />
          </ThemeIcon>
          <Title c="primary" order={5}>
            Prothèses
          </Title>
        </Group>
        {products.map((product, index) => (
          <Box key={index}>
            <Divider />
            <Group align="flex-start" gap={0}>
              <Text fw={500} c="gray">
                #{index + 1}
              </Text>
              <ProductDetails
                product={product}
                onEdit={() => onEdit(product.id)}
                onDelete={() => onDelete(product.id)}
              />
            </Group>
          </Box>
        ))}

        <UnstyledButton onClick={onAdd}>
          <Card
            variant="outline"
            bg="primaryLight.9"
            withBorder
            bd="dashed"
            c="primary"
            radius="md"
          >
            <Group justify="flex-start">
              <ThemeIcon size="xl">
                <IconPlus />
              </ThemeIcon>
              <Stack gap={0}>
                <Text fw={500} c="primary">
                  Ajouter une prothèse
                </Text>
                <Text>
                  Vous avez oublié une prothèse ? Ajoutez la sans recommencer.
                </Text>
              </Stack>
            </Group>
          </Card>
        </UnstyledButton>
      </Stack>
    </Paper>
  );
};
